<template lang="pug">
el-dialog(title='オプショナル要素追加', :visible.sync='visible', width='50%', :before-close='hideModal')
  ul.c-list__radio
    li
      el-radio(v-model='element', label='video', border='') 動画
    li
      el-radio(v-model='element', label='images', border='') 画像
    li
      el-radio(v-model='element', label='titletext', border='') タイトル&テキスト要素
    li
      el-radio(v-model='element', label='text', border='') テキスト要素
  span.dialog-footer(slot='footer')
    el-button(@click='hideModal') キャンセル
    el-button(type='primary', @click='hideModal') 追加
</template>

<script>
export default { name: 'ElementModalStoriesAddElement',
  data () {
    return {
      element: null
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    hideModal () {
      const template = {
        videoOrStill: {
          item_type: 'videoOrStill',
          image: {},
          video_uri: null
        },
        images: {
          item_type: 'images',
          images: []
        },
        image: {
          item_type: 'image',
          id: null,
          image: {}
        },
        video: {
          item_type: 'video',
          video_uri: null
        },
        titletext: {
          item_type: 'titleAndText',
          title: {
            ja: null,
            en: null
          },
          body: {
            ja: null,
            en: null
          }
        },
        text: {
          item_type: 'text',
          body: {
            ja: null,
            en: null
          }
        }
      }
      const data = template[this.element]
      this.$emit('hideModal', 'addelement', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Modal/AddStoriesElement/index.vue